import axios from "axios";
import store from "@/store";
import { Message } from "element-ui";

const service = axios.create({
  baseURL:
    process.env.NODE_ENV == "production" ? "https://expo.xinzhanbo.cn" : "/api",
  timeout: 5000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  (config) => {
    config.headers["token"] = store.state.user.token;
    config.headers["Cache-Control"] = "no-store";

    if (config.method === "get") {
      if (!config.params) {
        config.params = { did: store.state.user.did };
      } else {
        config.params.did = store.state.user.did;
      }
    }

    if (config.method === "post") {
      if (!config.data) {
        config.data = { did: store.state.user.did };
      } else {
        config.data.did = store.state.user.did;
      }
    }

    if (config.url == "/upload/file") {
      // 设置请求头
      config.headers["Content-Type"] = "multipart/form-data";
    }

    return config;
  },
  (error) => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  (response) => {
    const res = response.data;

    if (res.code == 200) {
      //请求成功
      return Promise.resolve(res);
    } else {
      Message.error(res.msg);
      return Promise.reject(res);
    }
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default service;
